import { CommonModule } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { CanPipe, ClientEnvironment, CommonUtilityLib, ENVIRONMENT } from '@thehubz/client/core';
import { CustomClients } from '@thehubz/shared/branding';
import { AnyType } from '@thehubz/shared/model';
import { Subscription, filter } from 'rxjs';
import { customerAssetInfoConfig } from '../../../customer/customer-asset-info-config';
import { AssetCommonService } from '../../../services/asset-common.service';
import { AssetAudioComponent } from './components/asset-audio/asset-audio.component';
import { AssetHtmlBannerComponent } from './components/asset-html-banner/asset-html-banner.component';
import { AssetImageComponent } from './components/asset-image/asset-image.component';
import { AssetMetadataComponent } from './components/asset-metadata/asset-metadata.component';
import { AssetPdfComponent } from './components/asset-pdf/asset-pdf.component';
import { AssetVideoComponent } from './components/asset-video/asset-video.component';
import { AssetViewComponent } from './components/asset-view/asset-view.component';
import { AssetMetadata } from './models/asset-info.interface';
import { assetMetadataConfig } from './models/asset-metadata-config';

@Component({
  selector: 'thehubz-asset-info',
  templateUrl: './asset-info.component.html',
  styleUrls: ['./asset-info.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    AssetViewComponent,
    AssetMetadataComponent,
    AssetImageComponent,
    AssetAudioComponent,
    AssetHtmlBannerComponent,
    AssetVideoComponent,
    AssetPdfComponent,
  ],
})
export class AssetInfoComponent implements OnInit, OnDestroy {
  assetInfo!: AnyType;
  assetInfoObject!: AssetMetadata;
  isExpanded = false;
  editFlag = false;
  btnDisabled = false;
  selectedTab = 0;
  docLoading = false;
  uploadInProgress = false;
  assetDataSubjectSubscription: Subscription | undefined;

  brandingKey!: CustomClients;
  CustomClients = CustomClients;

  constructor(
    @Inject(ENVIRONMENT) private readonly env: ClientEnvironment,
    private canPipe: CanPipe,
    private assetCommonService: AssetCommonService,
    private commonUtilityLib: CommonUtilityLib,
  ) {
    this.brandingKey = env.brandingKey ?? CustomClients.Standard;
  }

  ngOnInit() {
    this.assetDataSubjectSubscription = this.assetCommonService.assetDataSubject$
      .pipe(filter((asset) => !this.commonUtilityLib.isEmptyObject(asset)))
      .subscribe((data) => {
        if (data) {
          this.assetInfo = data;
          if ([this.CustomClients.VKB, this.CustomClients.SEAT].includes(this.env.brandingKey)) {
            this.assetInfoObject = {
              customerName: this.env.brandingKey,
              metadata: [],
            };
          } else {
            this.assetInfoObject =
              customerAssetInfoConfig(this.assetInfo, this.canPipe, this.env.brandingKey) ?? assetMetadataConfig(this.assetInfo, this.canPipe);
          }
        }
      });
  }

  expandCollapse() {
    this.isExpanded = !this.isExpanded;
  }

  stateUpdate(evt: boolean) {
    this.editFlag = evt;
  }

  ngOnDestroy(): void {
    if (this.assetDataSubjectSubscription) this.assetDataSubjectSubscription.unsubscribe();
  }
}
